<template lang="html">
    <canvas height="100" />
</template>

<script>
import Chart from 'chart.js';
import keys from 'lodash.keys';
import forEach from 'lodash.foreach';

export default {
    props: ['value'],
    data: function () {
        return {
            colors: [
                'rgba(255, 99, 132, 0.9)',
                'rgba(54, 162, 235, 0.9)',
                'rgba(255, 206, 86, 0.9)',
                'rgba(75, 192, 192, 0.9)',
                'rgba(153, 102, 255, 0.9)',
                'rgba(255, 159, 64, 0.9)'
            ]
        };
    },
    watch: {
        value: function () {
            var $this = this;
            var datasets = [];
            var labels = keys(this.value).sort(function (a, b) {
                var aa = parseInt(a.split('.').reverse().join(''));
                var bb = parseInt(b.split('.').reverse().join(''));
                return aa - bb;
            });
            var categories = {};
            forEach(labels, function (label) {
                forEach($this.value[label], function (value, category) {
                    if (category == '__total') {
                        return;
                    }
                    if (categories.hasOwnProperty(category) == false) {
                        categories[category] = [];
                    }
                    categories[category].push(value);
                });
            });
            var colorIndex = 0;
            forEach(categories, function (value, category) {
                if (colorIndex > 5) {
                    colorIndex = 0;
                }
                colorIndex++;
                datasets.push({
                    label: category,
                    data: categories[category],
                    borderColor: $this.colors[colorIndex],
                    borderWidth: 2,
                    backgroundColor: 'rgba(255, 255, 255, 0)'
                });
            });
            if (typeof this._chart == 'object') {
                this._chart.destroy();
            }
            this._chart = new Chart(this.$el, {
                type: 'line',
                data: {
                    labels: labels,
                    datasets: datasets
                },
                options: {
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero:true
                            }
                        }]
                    }
                }
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// chart.vue?1f71eddb